import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LayoutState, layoutFeatureKey } from './layout.reducer';

export const selectLayoutFeature = createFeatureSelector<LayoutState>(layoutFeatureKey);

export const selectSideMenuExpanded = createSelector(selectLayoutFeature, (state) => state.sideMenuExpanded);
